import {prependToLimited} from 'utils/array';

import * as backend from 'backend-helpers/member';
import * as memberPersonalRoomsBackend from 'backend-helpers/memberPersonalRooms';

const GET_MEMBER_REQUEST = 'GET_MEMBER_REQUEST';
const GET_MEMBER_SUCCESS = 'GET_MEMBER_SUCCESS';
const GET_MEMBER_FAILURE = 'GET_MEMBER_FAILURE';

const GET_MEMBER_PERSONAL_ROOM_REQUEST = "GET_MEMBER_PERSONAL_ROOM_REQUEST";
const GET_MEMBER_PERSONAL_ROOM_SUCCESS = "GET_MEMBER_PERSONAL_ROOM_SUCCESS";
const GET_MEMBER_PERSONAL_ROOM_FAILURE = "GET_MEMBER_PERSONAL_ROOM_FAILURE";

const MEMBER_PERSONAL_ROOM_ACTIVATED = "MEMBER_PERSONAL_ROOM_ACTIVATED";
const MEMBER_PERSONAL_ROOM_DEACTIVATED = "MEMBER_PERSONAL_ROOM_DEACTIVATED";

export const NICK_CHANGE_REQUEST_SENT = 'NICK_CHANGE_REQUEST_SENT';
export const AVATAR_CHANGED = 'AVATAR_CHANGED';

export const MEMBER_PHOTO_UPLOADED = 'MEMBER_PHOTO_UPLOADED';
export const MEMBER_PHOTO_DELETED = 'MEMBER_PHOTO_DELETED';
export const MEMBER_PHOTO_SAVED = 'MEMBER_PHOTO_SAVED';

const MEMBER_PHOTOS_PER_PAGE = 10;

export const MEMBER_VIRTUAL_GIFT_CHANGE_REQUEST = 'MEMBER_VIRTUAL_GIFT_CHANGE_REQUEST';
export const MEMBER_VIRTUAL_GIFT_CHANGE_SUCCESS = 'MEMBER_VIRTUAL_GIFT_CHANGE_SUCCESS';
export const MEMBER_VIRTUAL_GIFT_CHANGE_ERROR = 'MEMBER_VIRTUAL_GIFT_CHANGE_ERROR';

export const MEMBER_VIRTUAL_GIFT_DELETE_REQUEST = 'MEMBER_VIRTUAL_GIFT_DELETE_REQUEST';
export const MEMBER_VIRTUAL_GIFT_DELETE_SUCCESS = 'MEMBER_VIRTUAL_GIFT_DELETE_SUCCESS';
export const MEMBER_VIRTUAL_GIFT_DELETE_ERROR = 'MEMBER_VIRTUAL_GIFT_DELETE_ERROR';

export const MEMBER_GUESTBOOK_MESSAGE_ADDED = 'MEMBER_GUESTBOOK_MESSAGE_ADDED';

export const MEMBER_GUESTBOOK_DELETE_MESSAGE_REQUEST = 'MEMBER_GUESTBOOK_DELETE_MESSAGE_REQUEST';
export const MEMBER_GUESTBOOK_DELETE_MESSAGE_SUCCESS = 'MEMBER_GUESTBOOK_DELETE_MESSAGE_SUCCESS';
export const MEMBER_GUESTBOOK_DELETE_MESSAGE_ERROR = 'MEMBER_GUESTBOOK_DELETE_MESSAGE_ERROR';

export const MEMBER_DISABLE_GUESTBOOK_REQUEST = 'MEMBER_DISABLE_GUESTBOOK_REQUEST';
export const MEMBER_DISABLE_GUESTBOOK_SUCCESS = 'MEMBER_DISABLE_GUESTBOOK_SUCCESS';
export const MEMBER_DISABLE_GUESTBOOK_ERROR = 'MEMBER_DISABLE_GUESTBOOK_ERROR';

export const MEMBER_WALL_POST_DELETE_REQUEST = 'MEMBER_WALL_POST_DELETE_REQUEST';
export const MEMBER_WALL_POST_DELETE_SUCCESS = 'MEMBER_WALL_POST_DELETE_SUCCESS';
export const MEMBER_WALL_POST_DELETE_ERROR = 'MEMBER_WALL_POST_DELETE_ERROR';

export const MEMBER_VIDEO_DELETE_REQUEST = 'MEMBER_VIDEO_DELETE_REQUEST';
export const MEMBER_VIDEO_DELETE_SUCCESS = 'MEMBER_VIDEO_DELETE_SUCCESS';
export const MEMBER_VIDEO_DELETE_ERROR = 'MEMBER_VIDEO_DELETE_ERROR';

export const MEMBER_FOLLOW_PROFILE_REQUEST = 'MEMBER_FOLLOW_PROFILE_REQUEST';
export const MEMBER_FOLLOW_PROFILE_SUCCESS = 'MEMBER_FOLLOW_PROFILE_SUCCESS';
export const MEMBER_FOLLOW_PROFILE_FAILURE = 'MEMBER_FOLLOW_PROFILE_FAILURE';

export const MEMBER_UNFOLLOW_PROFILE_REQUEST = 'MEMBER_UNFOLLOW_PROFILE_REQUEST';
export const MEMBER_UNFOLLOW_PROFILE_SUCCESS = 'MEMBER_UNFOLLOW_PROFILE_SUCCESS';
export const MEMBER_UNFOLLOW_PROFILE_FAILURE = 'MEMBER_UNFOLLOW_PROFILE_FAILURE';

export const MEMBER_BLACKLIST_ADD_REQUEST = 'MEMBER_BLACKLIST_ADD_REQUEST';
export const MEMBER_BLACKLIST_ADD_SUCCESS = 'MEMBER_BLACKLIST_ADD_SUCCESS';
export const MEMBER_BLACKLIST_ADD_FAILURE = 'MEMBER_BLACKLIST_ADD_FAILURE';

export const MEMBER_BLACKLIST_DELETE_REQUEST = 'MEMBER_BLACKLIST_DELETE_REQUEST';
export const MEMBER_BLACKLIST_DELETE_SUCCESS = 'MEMBER_BLACKLIST_DELETE_SUCCESS';
export const MEMBER_BLACKLIST_DELETE_FAILURE = 'MEMBER_BLACKLIST_DELETE_FAILURE';

const initState = {
    nickChangeRequestSent: false,
    stats: {
        viewCount: 0,
        followerCount: 0
    },
    memberPhotos: {
        list: [],
        totalCount: 0
    },
    amateurFilms: {
        list: [],
        totalCount: 0
    },
    wallMaterials: {
        list: [],
        totalCount: 0
    },
    virtualGifts: {
        list: [],
        totalCount: 0
    },
    wishlist: [],
    guestbookMessages: {
        list: [],
        totalCount: 0
    },
    personalRoom: null
};

export default function member(state = initState, action) {
    if (action.type === GET_MEMBER_SUCCESS) {
        let {status, ...rest} = action.result.data;

        return {
            ...rest
        }
    }

    if (action.type === NICK_CHANGE_REQUEST_SENT) {
        return {
            ...state,
            nickChangeRequestSent: true
        }
    }

    if (action.type === GET_MEMBER_PERSONAL_ROOM_SUCCESS) {
        return {
            ...state,
            personalRoom: action.result.room
        };
    }

    if (action.type === MEMBER_PERSONAL_ROOM_ACTIVATED || action.type === MEMBER_PERSONAL_ROOM_DEACTIVATED) {
        let personalRoomActive = action.type === MEMBER_PERSONAL_ROOM_ACTIVATED;

        return {
            ...state,
            personalRoom: {
                ...state.personalRoom,
                active: personalRoomActive
            }
        }
    }

    if (action.type === MEMBER_PHOTO_UPLOADED) {
        return {
            ...state,
            memberPhotos: {
                list: prependToLimited(state.memberPhotos.list, action.memberPhoto, MEMBER_PHOTOS_PER_PAGE),
                totalCount: state.memberPhotos.totalCount+1
            }
        }
    }

    if (action.type === MEMBER_PHOTO_DELETED) {
        return {
            ...state,
            memberPhotos: {
                list: state.memberPhotos.list.filter((memberPhoto) => memberPhoto.id !== action.id),
                totalCount: state.memberPhotos.totalCount-1
            }
        }
    }

    if (action.type === MEMBER_PHOTO_SAVED) {
        return {
            ...state,
            memberPhotos: {
                ...state.memberPhotos,
                list: state.memberPhotos.list.map((memberPhoto) => memberPhoto.id !== action.memberPhoto.id ? memberPhoto : action.memberPhoto),
            }
        }
    }

    if (action.type === MEMBER_VIRTUAL_GIFT_CHANGE_SUCCESS) {
        return {
            ...state,
            virtualGifts: {
                ...state.virtualGifts,
                list: state.virtualGifts.list.map((virtualGift) => virtualGift.id !== action.result.virtualGift.id ? virtualGift : action.result.virtualGift)
            }
        }
    }

    if (action.type === MEMBER_GUESTBOOK_DELETE_MESSAGE_SUCCESS) {
        let new_list = state.guestbookMessages.list.filter((item) => item.id !== action.id),
            is_update_needed = (state.guestbookMessages.list.length > 0 && new_list.length != state.guestbookMessages.list.length);

        if (is_update_needed) {
            return {
                ...state,
                guestbookMessages: {
                    list: new_list,
                    totalCount: state.guestbookMessages.totalCount - 1
                }
            }
        }
    }

    if (action.type === MEMBER_WALL_POST_DELETE_SUCCESS) {
        let new_list = state.wallMaterials.list.filter((item) => item.id !== action.id),
            is_update_needed = (state.wallMaterials.list.length > 0 && new_list.length != state.wallMaterials.list.length);

        if (is_update_needed) {
            return {
                ...state,
                wallMaterials: {
                    list: new_list,
                    totalCount: state.wallMaterials.totalCount - 1
                }
            }
        }
    }

    return state;
}

export function getMember() {
    return {
        types: [GET_MEMBER_REQUEST, GET_MEMBER_SUCCESS, GET_MEMBER_FAILURE],
        promise: backend.getMember({mpl: MEMBER_PHOTOS_PER_PAGE})
    }
}

export function getMemberPersonalRoom(data)
{
    return {
        types: [GET_MEMBER_PERSONAL_ROOM_REQUEST, GET_MEMBER_PERSONAL_ROOM_SUCCESS, GET_MEMBER_PERSONAL_ROOM_FAILURE],
        promise: memberPersonalRoomsBackend.getMemberPersonalRoom()
    }
}

export function memberPersonalRoomActivated(roomid) {
    return {
        type: MEMBER_PERSONAL_ROOM_ACTIVATED,
        roomid
    }
}

export function memberPersonalRoomDeactivated(roomid) {
    return {
        type: MEMBER_PERSONAL_ROOM_DEACTIVATED,
        roomid
    }
}

export function nickChangeRequestSent() {
    return {
        type: NICK_CHANGE_REQUEST_SENT,
    }
}

export function avatarChanged(avatarUrl) {
    return {
        type: AVATAR_CHANGED,
        avatarUrl
    }
}

export function memberPhotoUploaded(memberPhoto) {
    return {
        type: MEMBER_PHOTO_UPLOADED,
        memberPhoto
    }
}

export function memberPhotoDeleted(id) {
    return {
        type: MEMBER_PHOTO_DELETED,
        id
    }
}

export function memberPhotoSaved(memberPhoto) {
    return {
        type: MEMBER_PHOTO_SAVED,
        memberPhoto
    }
}

export function deleteMemberVirtualGift(id) {
    return {
        types: [MEMBER_VIRTUAL_GIFT_DELETE_REQUEST, MEMBER_VIRTUAL_GIFT_DELETE_SUCCESS, MEMBER_VIRTUAL_GIFT_DELETE_ERROR],
        promise: backend.deleteMemberVirtualGift({id}),
        id
    }
}

export function toggleMemberVirtualGiftHidden(virtualGift) {
    return {
        types: [MEMBER_VIRTUAL_GIFT_CHANGE_REQUEST, MEMBER_VIRTUAL_GIFT_CHANGE_SUCCESS, MEMBER_VIRTUAL_GIFT_CHANGE_ERROR],
        promise: backend.toggleMemberVirtualGiftHidden(virtualGift)
    }
}

export function memberGuestbookMessageAdded({guestbookMessage, user}) {
    return {
        type: MEMBER_GUESTBOOK_MESSAGE_ADDED,
        guestbookMessage,
        user
    }
}

export function memberDeleteGuestbookMessage(id) {
    return {
        types: [MEMBER_GUESTBOOK_DELETE_MESSAGE_REQUEST, MEMBER_GUESTBOOK_DELETE_MESSAGE_SUCCESS, MEMBER_GUESTBOOK_DELETE_MESSAGE_ERROR],
        promise: backend.deleteGuestbookMessage(id),
        id
    }
}

export function memberDeleteWallPost(id) {
    return {
        types: [MEMBER_WALL_POST_DELETE_REQUEST, MEMBER_WALL_POST_DELETE_SUCCESS, MEMBER_WALL_POST_DELETE_ERROR],
        promise: backend.deleteWallPost({id:id}),
        id
    }
}

export function memberDeleteVideo(id) {
    return {
        types: [MEMBER_VIDEO_DELETE_REQUEST, MEMBER_VIDEO_DELETE_SUCCESS, MEMBER_VIDEO_DELETE_ERROR],
        promise: backend.deleteVideo({id:id}),
        id
    }
}

export function memberDisableMyGuestbook(guestbookDisabled) {
    return {
        types: [MEMBER_DISABLE_GUESTBOOK_REQUEST, MEMBER_DISABLE_GUESTBOOK_SUCCESS, MEMBER_DISABLE_GUESTBOOK_ERROR],
        promise: backend.disableMyGuestbook(guestbookDisabled),
        guestbookDisabled
    }
}

export function followProfile(id, user) {
    return {
        types: [MEMBER_FOLLOW_PROFILE_REQUEST, MEMBER_FOLLOW_PROFILE_SUCCESS, MEMBER_FOLLOW_PROFILE_FAILURE],
        promise: backend.followProfile(id),
        id,
        user
    }
}

export function unfollowProfile(id) {
    return {
        types: [MEMBER_UNFOLLOW_PROFILE_REQUEST, MEMBER_UNFOLLOW_PROFILE_SUCCESS, MEMBER_UNFOLLOW_PROFILE_FAILURE],
        promise: backend.unfollowProfile(id),
        id
    }
}

export function blackListUser(id, user, reason, type) {
    return {
        types: [MEMBER_BLACKLIST_ADD_REQUEST, MEMBER_BLACKLIST_ADD_SUCCESS, MEMBER_BLACKLIST_ADD_FAILURE],
        promise: backend.blackListUser({id, reason, type}),
        id
    }
}

export function unBlackListUser(id) {
    return {
        types: [MEMBER_BLACKLIST_DELETE_REQUEST, MEMBER_BLACKLIST_DELETE_SUCCESS, MEMBER_BLACKLIST_DELETE_FAILURE],
        promise: backend.unBlackListUser(id),
        id
    }
}


// WEBPACK FOOTER //
// ./src/reducers/member.js